/**
* @Author: zachalam
* @Date:   2017-01-23T15:07:27-08:00
* @Last modified by:   zachalam
* @Last modified time: 2017-01-24T12:06:20-08:00
*/

import * as sdk from '../sdk';
import { refreshProfile, showTOS } from './profileActions';
import { storeErrors, clearErrors, setLoading } from './commonActions';
import { toast } from 'react-toastify';
import { browserHistory } from 'react-router';
import store from '../store';

export const saveToken = (payload) => {
  return {
    type: 'LOGIN_USER',
    payload
  }
}

export const killToken = () => {
  return {
    type: 'LOGOUT_USER',
    payload: { isAuthenticated: false, jwToken: false }
  }
}


export const storeHttpRequest = (payload) => dispatch => {
   dispatch({
    type: 'STORE_HTTP_REQUEST',
    payload
  });
  return Promise.resolve();
}

export const removeHttpRequest = (payload) => dispatch => {
   dispatch({
    type: 'REMOVE_HTTP_REQUEST',
    payload
  });
  return Promise.resolve();
}

export const removeStaleHttpRequests = () => dispatch => {
  dispatch({
    type: 'REMOVE_STALE_HTTP_REQUESTS'
  });
  return Promise.resolve();
}

export const loginUserAction = (login,pass) => {

  return (dispatch, getState) => {
    dispatch(setLoading());
    return sdk.getAuthToken(login,pass)
              .then((response) => {
                // save token
                dispatch(saveToken(response.data));
                // scroll to top of page
                window.scrollTo(0,0)
                // retrieve logged in profile.
                dispatch(refreshProfile())
                  .then((r) => {
                    //console.log("refreshing profile");
                    // hide loading
                    dispatch(setLoading());
                    // clear errors
                    dispatch(clearErrors());
                    // redirect user
                    //console.log("redirecting now");
                    if(r.profile === undefined) {
                      // need to complete join-profile
                      browserHistory.push("/join-profile");
                    } else {
                      // all done, can login.
                      browserHistory.push("/search");
                    }

                  })
              });

  }

}

export const refreshUserToken = () => {

  var freshTokenPromise =
  sdk.getNewAuthToken()
            .then((response) => {
              // token received, save new token
              store.dispatch(saveToken(response.data));
              store.dispatch({type: 'DONE_REFRESHING_TOKEN'});

              return response.data.token ? Promise.resolve(response.data.token) : Promise.reject({message: 'could not refresh'});
            })
            .catch((error) => {
              // could not refresh token -> send user to login form
              browserHistory.push("/logout");
              return Promise.reject(error);
            })

  store.dispatch({type: 'REFRESHING_TOKEN', payload: freshTokenPromise })

  return freshTokenPromise;
}

export const logoutUserAction = () => {

  return (dispatch, getState) => {
    return sdk.killAuthToken(getState().auth.jwToken)
            .then((response) => {
              dispatch(killToken());
            });
  }

}

export const createAccountAction = (email,username,password,password_confirm,
  agreements,promo,ref,referral,radio_code) => {
  return (dispatch, getState) => {
    // require TOS to be showed.
    dispatch(showTOS());
    return sdk.createUserAccount(email,username,password,password_confirm,
      agreements,promo,ref,referral,radio_code);
  }
}


export const requestPassReminder = (email) => {
  return (dispatch, getState) => {
    return sdk.requestPassReminder(email)
              .then((response) => {
                // password reminder accepted.
                dispatch(clearErrors());
                toast('Password Reminder Sent!', {type: toast.TYPE.INFO});

              })
              .catch((error) => {
                // not valid email.
                dispatch(storeErrors(error.response.data));
              });
  }
}

export const setNewPassword = (formData) => {
  return (dispatch, getState) => {
    return sdk.setNewPassword(formData)
              .then((response) => {
                // new password accepted
                window.location = "/login";
                toast('Password Reset!', {type: toast.TYPE.INFO});
                return response;
              })
              .catch((error) => {
                // new password not accepted.
                try {
                  let { data } = error.response;
                  dispatch(storeErrors(data));
                } catch(e) {
                  //console.log(e);
                  window.location = "/login";
                }
              });
  }
}


export const deactivateAccount = (password) => {
  return (dispatch, getState) => {
    return sdk.deactivateAccount(getState().auth.jwToken,password)
              .then((response) => {
                // account deactivated, auth killed by server.
                // log user out
                browserHistory.push("/logout");
                toast('Account successfully deactivated!', {type: toast.TYPE.INFO});

              })
              .catch((error) => {
                // account could not deactivate.
                dispatch(storeErrors(error.response.data));
              })
  }
}

export const resendEmail = () => {
  return (dispatch, getState) => {
    console.log("woah, state");
    console.log(getState());
    return sdk.resendEmail(getState().auth.jwToken)
              .then((response) => {
                // email reminder sent - show notification.
                toast('Email Reminder Sent', {type: toast.TYPE.INFO});

              })
              .catch((error) => {
                // account could not resend email.
              })
  }
}



// WEBPACK FOOTER //
// ./src/actions/authActions.js